import React, { useEffect, useRef, useState } from "react";
import "../assets/styles/vipClient.scss";
import Footer from "../components/Footer";
import Header from "../components/Header";
import { FaChevronLeft } from "react-icons/fa";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useNavigate } from "react-router-dom";
function VipClient() {

  const scaleWrapperRef = useRef(null);
  const vipBannerRef = useRef(null);
  const mainContainerRef = useRef(null);
  const [goftinoReady, setGoftinoReady] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
    gsap.registerPlugin(ScrollTrigger);
  
    const bannerBg = vipBannerRef.current;
    const mainContainer = mainContainerRef.current;
  
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: scaleWrapperRef.current,
        start: "top top",
        end: "+=1200", // longer scroll = slower scale
        scrub: true,
      }
    });
  
    tl.to(bannerBg, {
      scale: 2,
      backgroundColor: "#F3FAFA",
      opacity: 0.8, // optional softness
      ease: "none"
    })
    .to(mainContainer, {
      backgroundColor: "#F3FAFA",
      ease: "none"
    }, "<");
  
    return () => {
      ScrollTrigger.getAll().forEach(trigger => trigger.kill());
    };
  }, []);

  useEffect(() => {
    const handleGoftinoReady = () => {
      setGoftinoReady(true);
    };

    window.addEventListener('goftino_ready', handleGoftinoReady);

    return () => {
      window.removeEventListener('goftino_ready', handleGoftinoReady);
    };
  }, []);
  
  const openChat = () => {
      window.Goftino.open();
  };
  
  return (
    <div  className="vip-container">
        <Header />
      <div  className="main-vip-container">
        <div className="vip-banner-wrapper" ref={scaleWrapperRef}>
          <div className="vip-banner-scaler">
            <div className="vip-banner-bg" ref={vipBannerRef}></div>
          </div>
          <div className="vip-banner">
            <h1>مشتریان ویژه تجاری</h1>
            <p>ارسال بار شرکت‌ها، موسسات و مراکز تجاری، بازرگانی، صنعتی، خدماتی و فروشگاه‌های آنلاین با شرایط ویژه زمانی، نرخی و بیمه‌ای.</p>
            <img src={require("../assets/images/vipBanner.png")} alt="vip banner" />
          </div>
        </div>
        <div ref={mainContainerRef} className="vip-services-container">
        <div className="header-texts">
            <span>خدمات و امکانات</span>
            <h2>ما خدمات و امکانات متفاوتی را برای شما مشتریان ویژه تجاری فرا هم کرده‌ایم.</h2>
            <p>ارائه سرویس درب‌به‌درب حمل‌ونقل وطن،  توافق‌نامه با مشتریان ویژه تجاری، تحویل آنی و ويژه بار در مقصد نهایی، ارائه خدمات رایگان لیفتراک و تخلیه بار و هم‌چنین اختصاص محل ویژه بارانداز برای مشتریان ویژه تجاری، بخشی از این خدمات و امکانات می‌باشند.</p>
        </div>

        <div className="service-card">
        <img src={require('../assets/images/vip1.png')} alt="vip pic"/>

            <div className="text-box">
              <p className="text-box-title">
              ارائه سرویس درب‌به‌درب -door to door توسط ناوگان درون شهری وطن
                </p>
              <p>بار شما را در هر نقطه از تهران و حومه که محل کسب‌وکار شماست دریافت کرده، به ترمینال مرکزی باربری وطن انتقال داده و سپس در شهر مقصد، تحویل شما یا مشتریان‌تان خواهیم داد. </p>
              <button onClick={openChat} className="expand-btn">
                <div><FaChevronLeft/></div>
                درخواست سرویس درب‌به‌درب
              </button>
            </div>
        </div>

        <div style={{flexDirection:'row-reverse'}} className="service-card">
        <img src={require('../assets/images/vip2.png')} alt="vip pic"/>

            <div className="text-box">
              <span>توافق‌نامه با شرکت‌ها و موسسات تجاری، بازرگانی، صنعتی و خدماتی و فروشگاه‌های آنلاین</span>
              <p>ما شرایط ویژه زمانی، نرخی و بیمه‌ای را متناسب با کسب‌وکار و نوع محموله ارسالی شما تنظیم خواهیم کرد تا از بهترین شرایط ارسال بار به نقاط مختلف کشور برخوردار شوید.</p>
              <button onClick={openChat} className="expand-btn">
                <div><FaChevronLeft/></div>
                تماس با واحد مشتریان ویژه تجاری
              </button>
            </div>
        </div>

        <div className="service-card">
        <img src={require('../assets/images/vip3.png')} alt="vip pic"/>

            <div className="text-box">
              <span>تحویل آنی و ویژه بار در مقصد نهایی توسط شعب و نمایندگی‌های انحصاری</span>
              <p>با در اختیار داشتن بیش از ۳۰۰ شعبه و نمایندگی انحصاری و استانداردسازی شده در سراسر کشور، این امکان را داریم تا محموله شما را به صورت آنی و با شرایط ویژه در مقصد نهایی تحویل دهیم.</p>
              <a href="/contact#department-map" target="_blank" className="expand-btn">
                <div><FaChevronLeft/></div>
                شهرهای تحت پوشش باربری وطن
              </a>
            </div>
        </div>

        <div className="features-container">
            <div className="feature-item">
                <img src={require('../assets/images/feature1.png')} alt="feature image"/>
                <span>اختصاص محل ویژه بارانداز</span>
                <p>محل ویژه‌ای جهت بارانداز بار ورودی شما به باربری وطن (تخلیه و توزیع در انبارهای خطوط) در ترمینال مرکزی اختصاص داده‌ایم.</p>
            </div>

            <div className="feature-item">
                <img src={require('../assets/images/feature2.png')} alt="feature image"/>
                <span>ارائه خدمات رایگان تخلیه بار</span>
                <p>خدمات تخلیه بار ورودی شما به باربری وطن را جهت پذیرش در ترمینال مرکزی به صورت رایگان ارائه می‌دهیم.</p>
            </div>

            <div className="feature-item">
                <img src={require('../assets/images/feature3.png')} alt="feature image"/>
                <span>ارائه خدمات رایگان لیفتراک</span>
                <p>در باربری وطن، خدمات لیفتراک را جهت پذیر، جابجایی و تحویل بار شما در ترمینال مرکزی، شعب و نمایندگی‌‌های سراسر کشور به صورت رایگان ارائه می‌دهیم.</p>
            </div>
        </div>
        </div>
        <div className="vip-bg-bleed-footer">
          <Footer bgColor={'#fff'} />
        </div>
      </div>
    </div>
  );
}

export default VipClient;
